import Message from '../components/messages/Message';
import type { AuthPromptStatus } from '../controllers/IntegrationsController';
import React from 'react';

const IntegrationAuthPrompt: React.FC<{
  authPromptStatus: AuthPromptStatus;
}> = ({ authPromptStatus }) => {
  if (authPromptStatus.status !== 'active') return null;
  if (authPromptStatus.promptType !== 'message') return null;

  return (
    <Message
      confirm={() => authPromptStatus.action(true)}
      confirmText='Authenticate'
      dismiss={() => authPromptStatus.action(false)}
    >
      {authPromptStatus.mode === 'reconnect' ? (
        <>
          Your {authPromptStatus.service.title} connection expired. Would you
          like to reconnect?
        </>
      ) : (
        <>Log in to {authPromptStatus.service.title} to refresh issue details</>
      )}
    </Message>
  );
};

export default IntegrationAuthPrompt;
